<template>
  <div id="AboutMeText1" style="z-index: 1;" :class="sectionClass">
    <p
      >Whether it’s an abstract artwork or a letter of the alphabet, in Nathan’s
      world, everything is alive. Nothing is exempt from having to deal with
      everyday life in all its complexity… and mundanity.</p
    >
    <StickMe
      name="24"
      size="20"
      left="-73"
      top="40"
      style="z-index: -1;"
      uk-parallax="x: 1000%; y: -100%, 420%"
    />
  </div>
</template>

<script>
import { isMobile } from '@/helpers'
import StickMe from './StickMe.vue'

export default {
  components: { StickMe },
  computed: {
    sectionClass() {
      return {
        section: !this.isMobile(),
        sectionMobile: this.isMobile(),
      }
    },
  },
  methods: {
    isMobile,
  },
}
</script>

<style lang="scss" scoped>
.section {
  padding-bottom: 22%;
}

.sectionMobile {
  padding-bottom: 22%;
  font-size: small;
}
</style>



// WEBPACK FOOTER //
// src/components/about-me/AboutMeText1.vue